/**
 * @generated SignedSource<<a7b6192e241bff817293e89536fb54d7>>
 * @relayHash 5af65462c60885c21e1ab5b9e7fe7bcd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 28980e6494a8955ea545f2049a61094e488898b5d096195ce03d5df5cd90873c

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraRankMutationEdge = "BOTTOM" | "TOP" | "%future added value";
export type JiraRankMutationInput = {
  edge: JiraRankMutationEdge;
  issues: ReadonlyArray<string>;
  relativeToIssue: string;
};
export type rankMutation_rankIssuesMutation$variables = {
  rankInput: JiraRankMutationInput;
};
export type rankMutation_rankIssuesMutation$data = {
  readonly jira: {
    readonly rankIssues: {
      readonly errors: ReadonlyArray<{
        readonly extensions: {
          readonly errorType: string | null | undefined;
          readonly statusCode: number | null | undefined;
        } | null | undefined;
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type rankMutation_rankIssuesMutation = {
  response: rankMutation_rankIssuesMutation$data;
  variables: rankMutation_rankIssuesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "rankInput"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "rankInput",
    "variableName": "rankInput"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "message"
},
v4 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v5 = {
  "kind": "ScalarField",
  "name": "errorType"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "rankMutation_rankIssuesMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraRankMutationPayload",
            "kind": "LinkedField",
            "name": "rankIssues",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "rankMutation_rankIssuesMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraRankMutationPayload",
            "kind": "LinkedField",
            "name": "rankIssues",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v4/*: any*/),
                      (v5/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "id"
                          }
                        ],
                        "type": "BulkMutationErrorExtension"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "28980e6494a8955ea545f2049a61094e488898b5d096195ce03d5df5cd90873c",
    "metadata": {},
    "name": "rankMutation_rankIssuesMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "4dde1357f9a06e5132a41d95c199765c";

export default node;
